import TrainingSession from 'actions/training/session';

export default TrainingSession.createReducer();